import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsCloudUpload } from "react-icons/bs";
import { IoIosArrowRoundBack } from "react-icons/io";

import styles from "./Form.module.css";

import { useGetPreSignedUrlMutation } from "../../redux/api/uploadApi";

import {
  useGetPcategoriesDropDownQuery,
  useGetcategoriesDropDownQuery,
} from "../../redux/api/classifiedApi";

import {
  useGetDistrictsQuery,
  useGetCountriesSelectedQuery,
  useGetAreaDistrictsQuery,
} from "../../redux/api/regionApi";

const EditAutomotiveClassified = ({
  classified,
  classified_id,
  setEdit,
  refetch,
}) => {
  const navigate = useNavigate();
  const filePikerRef = useRef(null);

  const [getPreSignedUrl] = useGetPreSignedUrlMutation();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [imgsrc, setImagesrc] = useState("");
  const [imgeFile, setImgeFile] = useState(null);

  const [formData, setFormData] = useState({
    country_id: "KW",
    district_id: "",
    area_id: "",
    address: "",
    title: "",
    mobile: "",
    price: "",
    description: "",
    leaseType: "",
    model: "",
    fuelType: "",
    transmission: "",
    cylinder: "",
    isFullOption: false,
    isInsured: false,
  });

  /*
   * ---------------------------------------------------------
   * Fill form from classified details
   * ---------------------------------------------------------
   */

  useEffect(() => {
    if (!classified) return;

    setFormData({
      country_id: classified.country_id?._id
        ? classified.country_id._id
        : classified.country_id || "KW",

      district_id: classified.district_id?._id
        ? classified.district_id._id
        : classified.district_id || "",

      area_id: classified.area_id?._id
        ? classified.area_id._id
        : classified.area_id || "",

      address: classified.address || "",
      title: classified.title || "",
      mobile: classified.mobile || "",
      price: classified.price ?? "",
      description: classified.description || "",

      leaseType: classified.leaseType?._id
        ? classified.leaseType._id
        : classified.leaseType || "",

      model: classified.model?._id
        ? classified.model._id
        : classified.model || "",

      fuelType: classified.fuelType?._id
        ? classified.fuelType._id
        : classified.fuelType || "",

      transmission: classified.transmission?._id
        ? classified.transmission._id
        : classified.transmission || "",

      cylinder: classified.cylinder?._id
        ? classified.cylinder._id
        : classified.cylinder || "",

      isFullOption: Boolean(classified.isFullOption),
      isInsured: Boolean(classified.isInsured),
    });

    /*
     * Existing image
     */
    if (classified.media?.length > 0) {
      const image = classified.media.find((item) => item.type === "image");

      if (image?.url) {
        setImagesrc(image.url);
      }
    }
  }, [classified]);

  /*
   * ---------------------------------------------------------
   * Dropdown APIs
   * ---------------------------------------------------------
   */

  const categoryId =
    classified?.category_id?._id || classified?.category_id || classified_id;

  const {
    data: modelData,
    error: modelError,
    isSuccess: modelSuccess,
  } = useGetcategoriesDropDownQuery({
    idName: "model",
    category_id: categoryId,
  });

  const {
    data: fuelTypeData,
    error: fuelTypeError,
    isSuccess: fuelTypeSuccess,
  } = useGetcategoriesDropDownQuery({
    idName: "fuel_type",
    category_id: categoryId,
  });

  const {
    data: transmissionData,
    error: transmissionDataError,
    isSuccess: transmissionDataSuccess,
  } = useGetcategoriesDropDownQuery({
    idName: "transmission",
    category_id: categoryId,
  });

  const {
    data: cylinderData,
    error: cylinderDataError,
    isSuccess: cylinderDataSuccess,
  } = useGetcategoriesDropDownQuery({
    idName: "cylinder",
    category_id: categoryId,
  });

  const {
    data: catPData,
    error: catPError,
    isSuccess: careerPSuccess,
  } = useGetPcategoriesDropDownQuery({
    category_id: categoryId,
  });

  /*
   * ---------------------------------------------------------
   * Country / District / Area
   * ---------------------------------------------------------
   */

  const { data, error, isSuccess } = useGetCountriesSelectedQuery({});

  const {
    data: dataDiscrict,
    error: errorDistrict,
    isSuccess: successDistrict,
  } = useGetDistrictsQuery({
    country_id: formData.country_id || "KW",
    searchText: "",
  });

  const {
    data: dataArea,
    error: errorArea,
    isSuccess: successArea,
  } = useGetAreaDistrictsQuery(
    {
      district_id: formData.district_id,
      searchText: "",
    },
    {
      skip: !formData.district_id,
    },
  );

  /*
   * ---------------------------------------------------------
   * Handle input
   * ---------------------------------------------------------
   */

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  /*
   * ---------------------------------------------------------
   * Validation
   * ---------------------------------------------------------
   */

  const validateForm = () => {
    const newErrors = {};

    if (!formData.country_id) {
      newErrors.country = "Country is required";
    }

    if (!formData.district_id) {
      newErrors.district = "District is required";
    }

    if (!formData.address) {
      newErrors.address = "Other address is required";
    }

    if (!formData.title) {
      newErrors.title = "Title is required";
    }

    if (!formData.mobile) {
      newErrors.mobile = "Mobile is required";
    } else if (!/^\d*$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile must be a positive number";
    } else if (Number(formData.mobile) < 0) {
      newErrors.mobile = "Mobile cannot be negative";
    }

    if (!formData.price) {
      newErrors.price = "Price is required";
    } else if (!/^\d*$/.test(formData.price)) {
      newErrors.price = "Price must be a positive number";
    } else if (Number(formData.price) < 0) {
      newErrors.price = "Price cannot be negative";
    }

    if (!formData.leaseType) {
      newErrors.leaseType = "Lease Type is required";
    }

    if (!formData.model) {
      newErrors.model = "Car Model is required";
    }

    if (!formData.fuelType) {
      newErrors.fuelType = "Fuel Type is required";
    }

    if (!formData.transmission) {
      newErrors.transmission = "Transmission Type is required";
    }

    if (!formData.cylinder) {
      newErrors.cylinder = "Cylinder Count is required";
    }

    return newErrors;
  };

  /*
   * ---------------------------------------------------------
   * Select new image
   * ---------------------------------------------------------
   */

  const filePickerHandeler = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      setImgeFile(file);

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.addEventListener("load", () => {
        setImagesrc(reader.result);
      });
    }
  };

  /*
   * ---------------------------------------------------------
   * Submit
   * ---------------------------------------------------------
   */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) {
      return;
    }

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      /*
       * If user selected a NEW image,
       * upload it first.
       */

      if (imgeFile) {
        await getPresignedUrlAndUpload();
      } else {
        /*
         * No new image.
         * Update using existing image.
         */
        await updateClassified();
      }
    } catch (err) {
      console.error(err);

      setLoading(false);

      alert(err?.message || "Something went wrong while updating classified");
    }
  };

  /*
   * ---------------------------------------------------------
   * Get presigned URL
   * ---------------------------------------------------------
   */

  const getPresignedUrlAndUpload = async () => {
    try {
      const res = await getPreSignedUrl({
        fileNames: [imgeFile.name],
        contentType: imgeFile.type,
        flocation: "posts",
      });

      if (res.error) {
        handleApiError(res.error);
        return;
      }

      if (res.data?.preSignedUrls?.length > 0) {
        const presignedData = res.data.preSignedUrls[0];

        await uploadFile(
          presignedData.preSignedUrlToUplaodToAWS,
          presignedData.pathNametoStoreInDBaftersucessfullupload,
        );
      }
    } catch (err) {
      console.error(err);
      setLoading(false);

      alert(err?.message || "Image upload failed");
    }
  };

  /*
   * ---------------------------------------------------------
   * Upload image to AWS
   * ---------------------------------------------------------
   */

  const uploadFile = async (prsignedURL, storeTODB) => {
    try {
      await axios.put(prsignedURL, imgeFile, {
        headers: {
          "Content-Type": imgeFile.type,
        },

        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;

          if (total) {
            const percent = Math.floor((loaded * 100) / total);

            console.log(`Uploading: ${percent}%`);
          }
        },
      });

      /*
       * Image uploaded successfully.
       * Now update classified.
       */

      await updateClassified(storeTODB);
    } catch (err) {
      console.error(err);

      setLoading(false);

      alert("Image upload failed. Please try again.");
    }
  };

  /*
   * ---------------------------------------------------------
   * UPDATE CLASSIFIED
   * ---------------------------------------------------------
   */

  const updateClassified = async (newImageUrl = null) => {
    try {
      const payload = {
        ...formData,
      };

      /*
       * If new image was uploaded,
       * replace media.
       */
      if (newImageUrl) {
        payload.media = [
          {
            url: newImageUrl,
            type: "image",
          },
        ];
      }

      const user = JSON.parse(localStorage.getItem("RaselListing"));

      const response = await fetch(
        `${process.env.REACT_APP_backendurl}/api/classifieds/edit-classified/${classified_id}`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",

            ...(user?.token && {
              Authorization: `Bearer ${user?.token}`,
            }),
          },

          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      if (!response.ok) {
        if (response.status === 401) {
          alert("Not authorized, login again");

          window.location.href = "/rm-admin";

          return;
        }

        throw new Error(result?.error || "Failed to update classified");
      }

      if (result.classifiedUpdated) {
        alert("Classified updated successfully");
      }
      refetch();
      setEdit(false);
    } catch (err) {
      console.error(err);

      alert(err?.message || "Failed to update classified");
    } finally {
      setLoading(false);
    }
  };

  /*
   * ---------------------------------------------------------
   * API error handler
   * ---------------------------------------------------------
   */

  const handleApiError = (apiError) => {
    setLoading(false);

    if (apiError?.status === 401) {
      alert("Not authorized, login again");

      window.location.href = "/rm-admin";

      return;
    }

    alert(apiError?.data?.error || "Something went wrong");
  };

  /*
   * ---------------------------------------------------------
   * Render
   * ---------------------------------------------------------
   */

  return (
    <div className="root-top-margin" style={{ background: "white" }}>
      {/* API Errors */}

      {error?.data?.error && (
        <span className={styles.error}>{error.data.error}</span>
      )}

      {errorDistrict?.data?.error && (
        <span className={styles.error}>{errorDistrict.data.error}</span>
      )}

      {errorArea?.data?.error && (
        <span className={styles.error}>{errorArea.data.error}</span>
      )}

      {catPError?.data?.error && (
        <span className={styles.error}>{catPError.data.error}</span>
      )}

      {modelError?.data?.error && (
        <span className={styles.error}>{modelError.data.error}</span>
      )}

      {fuelTypeError?.data?.error && (
        <span className={styles.error}>{fuelTypeError.data.error}</span>
      )}

      {transmissionDataError?.data?.error && (
        <span className={styles.error}>{transmissionDataError.data.error}</span>
      )}

      {cylinderDataError?.data?.error && (
        <span className={styles.error}>{cylinderDataError.data.error}</span>
      )}

      {/* Back */}

      <IoIosArrowRoundBack
        size={40}
        style={{ cursor: "pointer" }}
        onClick={() => setEdit(false)}
      />

      <div
        style={{
          background: "white",
          width: "80%",
          margin: "auto",
          padding: "10px",
        }}
      >
        {/* IMAGE */}

        <div className={styles.imageWrapper}>
          <input
            type="file"
            ref={filePikerRef}
            accept="image/*"
            className="display-n"
            onChange={filePickerHandeler}
          />

          {/* {imgsrc && (
            <div className="text-align-center">
              <img src={imgsrc} alt="classified" className={styles.catImage} />

              <div
                className={styles.uploadImgButton}
                onClick={() => {
                  if (loading) {
                    alert("Please wait, updating...");
                  } else {
                    filePikerRef.current.click();
                  }
                }}
              >
                Change Image <BsCloudUpload />
              </div>
            </div>
          )} */}

          {/* {!imgsrc && (
            <div
              className={styles.uploadImgButton}
              onClick={() => {
                if (!loading) {
                  filePikerRef.current.click();
                }
              }}
            >
              Add Image <BsCloudUpload />
            </div>
          )} */}
        </div>

        {/* FORM */}

        <form className={styles.form} onSubmit={handleSubmit}>
          {/* COUNTRY */}

          <div className={styles.field}>
            <label htmlFor="country">Country</label>

            <select
              id="country"
              name="country_id"
              value={formData.country_id}
              onChange={handleChange}
            >
              {isSuccess &&
                data?.map((country) => (
                  <option value={country._id} key={country._id}>
                    {country.country_english}
                  </option>
                ))}
            </select>

            {errors.country && (
              <span className={styles.error}>{errors.country}</span>
            )}
          </div>

          {/* DISTRICT */}

          <div className={styles.field}>
            <label htmlFor="district">District</label>

            <select
              id="district"
              name="district_id"
              value={formData.district_id}
              onChange={handleChange}
            >
              <option value="">Select District</option>

              {successDistrict &&
                dataDiscrict?.map((district) => (
                  <option value={district._id} key={district._id}>
                    {district.district_en}
                  </option>
                ))}
            </select>

            {errors.district && (
              <span className={styles.error}>{errors.district}</span>
            )}
          </div>

          {/* AREA */}

          <div className={styles.field}>
            <label htmlFor="area">Area</label>

            <select
              id="area"
              name="area_id"
              value={formData.area_id}
              onChange={handleChange}
              disabled={!successArea}
            >
              <option value="">Select Area</option>

              {successArea &&
                dataArea?.map((area) => (
                  <option value={area._id} key={area._id}>
                    {area.area_en}
                  </option>
                ))}
            </select>

            {errors.area && <span className={styles.error}>{errors.area}</span>}
          </div>

          {/* ADDRESS */}

          <div className={styles.field}>
            <label htmlFor="address">Other Address</label>

            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
            />

            {errors.address && (
              <span className={styles.error}>{errors.address}</span>
            )}
          </div>

          {/* TITLE */}

          <div className={styles.field}>
            <label htmlFor="title">Title</label>

            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
            />

            {errors.title && (
              <span className={styles.error}>{errors.title}</span>
            )}
          </div>

          {/* MOBILE */}

          <div className={styles.field}>
            <label htmlFor="mobile">Mobile</label>

            <input
              type="text"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
            />

            {errors.mobile && (
              <span className={styles.error}>{errors.mobile}</span>
            )}
          </div>

          {/* PRICE */}

          <div className={styles.field}>
            <label htmlFor="price">Price</label>

            <input
              type="text"
              id="price"
              name="price"
              value={formData.price}
              onChange={handleChange}
            />

            {errors.price && (
              <span className={styles.error}>{errors.price}</span>
            )}
          </div>

          {/* LEASE TYPE */}

          <div className={styles.field}>
            <label htmlFor="leaseType">Lease Type</label>

            <select
              id="leaseType"
              name="leaseType"
              value={formData.leaseType}
              onChange={handleChange}
            >
              <option value="">Select Lease</option>

              {careerPSuccess &&
                catPData?.map((type) => (
                  <option value={type._id} key={type._id}>
                    {type.sub_category_en}
                  </option>
                ))}
            </select>

            {errors.leaseType && (
              <span className={styles.error}>{errors.leaseType}</span>
            )}
          </div>

          {/* MODEL */}

          <div className={styles.field}>
            <label htmlFor="model">Car Model</label>

            <select
              id="model"
              name="model"
              value={formData.model}
              onChange={handleChange}
            >
              <option value="">Select Car Model</option>

              {modelSuccess &&
                modelData?.map((model) => (
                  <option value={model._id} key={model._id}>
                    {model.value_en}
                  </option>
                ))}
            </select>

            {errors.model && (
              <span className={styles.error}>{errors.model}</span>
            )}
          </div>

          {/* FUEL */}

          <div className={styles.field}>
            <label htmlFor="fuelType">Fuel Type</label>

            <select
              id="fuelType"
              name="fuelType"
              value={formData.fuelType}
              onChange={handleChange}
            >
              <option value="">Select Fuel Type</option>

              {fuelTypeSuccess &&
                fuelTypeData?.map((fuel) => (
                  <option value={fuel._id} key={fuel._id}>
                    {fuel.value_en}
                  </option>
                ))}
            </select>

            {errors.fuelType && (
              <span className={styles.error}>{errors.fuelType}</span>
            )}
          </div>

          {/* TRANSMISSION */}

          <div className={styles.field}>
            <label htmlFor="transmission">Transmission Type</label>

            <select
              id="transmission"
              name="transmission"
              value={formData.transmission}
              onChange={handleChange}
            >
              <option value="">Select Transmission Type</option>

              {transmissionDataSuccess &&
                transmissionData?.map((transmission) => (
                  <option value={transmission._id} key={transmission._id}>
                    {transmission.value_en}
                  </option>
                ))}
            </select>

            {errors.transmission && (
              <span className={styles.error}>{errors.transmission}</span>
            )}
          </div>

          {/* CYLINDER */}

          <div className={styles.field}>
            <label htmlFor="cylinder">Cylinder Count</label>

            <select
              id="cylinder"
              name="cylinder"
              value={formData.cylinder}
              onChange={handleChange}
            >
              <option value="">Select Cylinder Count</option>

              {cylinderDataSuccess &&
                cylinderData?.map((cylinder) => (
                  <option value={cylinder._id} key={cylinder._id}>
                    {cylinder.value_en}
                  </option>
                ))}
            </select>

            {errors.cylinder && (
              <span className={styles.error}>{errors.cylinder}</span>
            )}
          </div>

          {/* CHECKBOXES */}

          <div>
            <div>
              <label>
                <input
                  type="checkbox"
                  name="isFullOption"
                  checked={formData.isFullOption}
                  onChange={handleChange}
                />

                <span className="ml-1">Full Option</span>
              </label>
            </div>

            <div>
              <label>
                <input
                  type="checkbox"
                  name="isInsured"
                  checked={formData.isInsured}
                  onChange={handleChange}
                />

                <span className="ml-1">Insured</span>
              </label>
            </div>
          </div>

          {/* DESCRIPTION */}

          <div className={styles.fieldFull}>
            <label htmlFor="description">Description</label>

            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </div>

          {/* SUBMIT */}

          <div className="display-flex" style={{ gap: "4px" }}>
            <div className={styles.fieldFull}>
              <button
                type="submit"
                className={styles.submitButton}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>

            {loading && (
              <div
                style={{
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <span className="loader-spiner"></span>

                <span className="text-primary">Updating....</span>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAutomotiveClassified;
